<template>
    <div class="formmail-container">
        <div class="formmail-table-caption">
            <h1 class="title">신청자정보입력</h1>
            <small><span class="color-red">*</span>필수입력입니다.</small>
        </div>
        <div class="formmail-table">
            <div class="row">
                <div class="th">
                    <label>고객명(거래처명)<span class="color-red">*</span></label>
                </div>
                <div class="td">
                    <input class="w300" type="text" v-model="inputs.name" @keyup="inputs.name = inputs.name.replace(/\s/g, '')" />
                </div>
            </div>
            <div class="row">
                <div class="th">
                    <label>연락처<span class="color-red">*</span></label>
                </div>
                <div class="td">
                    <div class="form-tel">
                        <input class="input" type="text" v-model="inputs.phone1" maxlength="4" @keyup="inputs.phone1 = inputs.phone1.replace(/[^0-9]/g, '')" />
                        <span class="text"></span>
                        <input class="input" type="text" v-model="inputs.phone2" maxlength="4" @keyup="inputs.phone2 = inputs.phone2.replace(/[^0-9]/g, '')" />
                        <span class="text"></span>
                        <input class="input" type="text" v-model="inputs.phone3" maxlength="4" @keyup="inputs.phone3 = inputs.phone3.replace(/[^0-9]/g, '')" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="th">주소<span class="color-red">*</span></div>
                <div class="td">
                    <div class="form-address">
                        <input class="input" type="text" name="postcode" placeholder="우편번호" v-model="inputs.postcode" @click="onSearchPostcode" readonly />
                        <button class="button button--primary" name="postcode" @click="onSearchPostcode">검색</button>
                        <input class="input" type="text" v-model="inputs.address1" @click="onSearchPostcode" readonly />
                        <input class="input" type="text" v-model="inputs.address2" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="th">
                    <label>상품코드 조회<span class="color-red">*</span></label>
                </div>
                <div class="td">
                    <div class="code">
                        <input id="product-code" class="input w300" type="text" v-model="inputs.product.code" :disabled="productNameEnabled" />
                        <button class="button button--primary" name="product-code" @click="onSearchProductcode">조회</button>
                        <a class="button-underline" href="#" @click="$refs['submission-modal'].openModal('code')"><span>상품코드 확인하기</span></a>
                    </div>
                    <div>
                        <div class="check-wrap">
                            <label class="check">
                                <input v-model="productNameEnabled" type="checkbox" id="prdocutNameEnabled" class="input" />
                                <i class="icon"></i>
                                <span class="text">상품코드를 모르실 경우 모델명 직접 입력하기</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="th">
                    <label>모델명<span class="color-red">*</span></label>
                </div>
                <div class="td">
                    <input class="w300" type="text" v-model="inputs.product.name" :disabled="!productNameEnabled" />
                    <a class="button-underline" href="#" @click="$refs['submission-modal'].openModal('model')"><span>모델명 확인하기</span></a>
                </div>
            </div>
            <div class="row">
                <div class="th">함께 보내는 물품 <br />(다중선택가능)<span class="color-red">*</span></div>
                <div class="td">
                    <div class="check-wrap">
                        <label v-for="(postItem, i) in sendingItems" :key="`submssion-item-checkbox-item-${i}`" class="check">
                            <input v-model="inputs.sendingItems" type="checkbox" :value="postItem === '기타' ? null : postItem" :id="`submssion-item-checkbox-item-${i}`" class="input" />
                            <i class="icon"></i>
                            <span :for="`submssion-item-checkbox-item-${i}`" class="text">{{ postItem }}</span>
                        </label>
                        <div v-if="inputs.sendingItems.includes(null)" class="check" style="width:100%">
                            <input type="text" v-model="inputs.sendingItemEtc" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="th">
                    <label>제목<span class="color-red">*</span></label>
                </div>
                <div class="td">
                    <input type="text" v-model="inputs.inquireTitle" />
                </div>
            </div>
            <div class="row">
                <div class="th">
                    <label>수리의뢰내용<span class="color-red">*</span></label>
                </div>
                <div class="td">
                    <textarea v-model="inputs.inquireDescription" />
                </div>
            </div>
            <div class="row">
                <div class="th">
                    <label>기타전달사항</label>
                </div>
                <div class="td">
                    <textarea v-model="inputs.inquireEtc" />
                </div>
            </div>
        </div>
        <div class="formmail-agreement">
            <label class="check">
                <input class="input" type="checkbox" name="agreed" v-model="agreed" />
                <i class="icon"></i>
                <span class="text">개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <a class="button button-underline" href="#" @click="$refs['submission-modal'].openModal('privacy')">전문보기</a>
        </div>
        <div class="formmail-buttons">
            <button @click="validate" class="button button--primary"><span>신청하기</span></button>
        </div>
        <daum-postcode ref="daum-postcode" @change="onChangePostcode"></daum-postcode>
        <submission-modal ref="submission-modal" />
    </div>
</template>
<script>
import api from "@/api";
import daumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import submissionInputsAgreement from "./submission-inputs-agreement";
import SubmissionModal from "./submission-modal.vue";

const initialInputs = {
    name: "",
    phone1: "",
    phone2: "",
    phone3: "",
    postcode: "",
    address1: "",
    address2: "",
    _product: undefined,
    product: {
        code: "",
        name: "",
    },
    sendingItems: [],
    sendingItemEtc: "",
    inquireTitle: "",
    inquireDescription: "",
    inquireEtc: "",
};

export default {
    components: {
        daumPostcode,
        SubmissionModal,
    },
    data() {
        return {
            inputs: { ...initialInputs },
            sendingItems: ["보증서", "로드케이스", "1절대(초릿대)", "2절대(손잡이대)", "기타"],
            submissionInputsAgreement,
            productNameEnabled: false,
            agreed: false,
        };
    },
    methods: {
        onSearchPostcode(event) {
            event.preventDefault();
            this.$refs["daum-postcode"].open();
        },

        onChangePostcode(data) {
            this.inputs.postcode = data.postcode;
            this.inputs.address1 = data.address;
        },

        async onSearchProductcode(event) {
            event.preventDefault();
            try {
                const { product } = await api.v1.products.getProduct({ code: this.inputs.product.code });
                if (product) {
                    const { code, name, _id: _product } = product;
                    this.inputs.product = { code, name };
                    this.inputs._product = _product;
                } else alert("조회하신 코드의 제품이 없습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },

        validate(event) {
            event.preventDefault();
            try {
                if (!this.agreed) throw new Error("개인정보 수집 및 이용 동의가 체크되지 않았습니다.");
                if (!this.inquiryData.inquirer.name.length) throw new Error("고객명이 입력되지 않았습니다.");
                if (this.inquiryData.inquirer.phone.length < 9) throw new Error("연락처가 입력되지 않았습니다.");
                if (!this.inquiryData.inquirer.postcode.length || !this.inquiryData.inquirer.address1.length || !this.inquiryData.inquirer.address2.length) throw new Error("주소가 입력되지 않았습니다");
                if (!this.inquiryData._product) {
                    if (!this.inquiryData.product.code.length && !this.inquiryData.product.name.length) throw new Error("제품코드 또는 모델명이 입력되지 않았습니다.");
                    if (!this.inquiryData.product.name.length) throw new Error("모델명이 입력되지 않았습니다.");
                }
                if (!this.inquiryData.sendingItems.length) throw new Error("함께 보내는 물품이 입력되지 않았습니다.");
                if (!this.inquiryData.inquire.title.length) throw new Error("제목이 입력되지 않았습니다.");
                if (!this.inquiryData.inquire.description.length) throw new Error("수리의뢰내용이 입력되지 않았습니다.");

                this.save();
            } catch (error) {
                this.handleError(error);
            }
        },

        async save() {
            try {
                const {
                    inquiry: { inquiryNumber },
                } = await api.v1.inquiries.postInquiry(this.inquiryData);
                this.$refs["submission-modal"].openModalWithMessage(`<div style="text-align:center;font-size:1.25em">A/S 접수가 완료되었습니다.<div style="margin-top:0.5em;font-size:1.25em">접수번호: <b>${inquiryNumber}</b></div></div>`);
                this.$emit("on-success");
                this.inputs = { ...initialInputs };
            } catch (error) {
                this.handleError(error);
            }
        },

        handleError(error) {
            console.error(error);
            if (error.response) alert(error.response.data.message);
            else alert(error.message);
        },
    },
    computed: {
        inquiryData() {
            const { name, phone1, phone2, phone3, postcode, address1, address2, _product, product, sendingItems: _sendingItems, sendingItemEtc, inquireTitle, inquireDescription, inquireEtc } = this.inputs;

            const phone = phone1 + phone2 + phone3;

            const productData = _product ? { _product } : { product };

            const sendingItems = [..._sendingItems];
            sendingItems[sendingItems.indexOf(null)] = sendingItemEtc;

            return {
                inquirer: {
                    name,
                    phone,
                    postcode,
                    address1,
                    address2,
                },
                ...productData,
                sendingItems,
                inquire: {
                    title: inquireTitle,
                    description: inquireDescription,
                    etc: inquireEtc,
                },
            };
        },
    },
};
</script>
